<template>
  <div class="flex flex-col justify-between bg-black-90 px-6 pb-6 pt-8 text-black-70">
    <div class="flex h-[90%] w-full flex-col items-start gap-4 4xl:gap-6 5xl:gap-8">
      <NuxtImg src="/images/logos/logo-white-horizontal.svg" />
      <NuxtLink
        class="flex h-12 w-full flex-row items-center gap-2 px-3 py-2.5 !text-white 4xl:h-20 4xl:text-3xl 5xl:h-24 5xl:text-4xl"
        :class="{ 'rounded-xl bg-black-70 ': $route.name?.toString().startsWith('index') }"
        :to="localePath('/')"
      >
        <UIIcon name="dashboard" />
        {{ $t('navigation.drawer.dashboard') }}
      </NuxtLink>
      <hr class="w-full border-t border-solid border-black-70" />
      <SupportAgentInfo />
    </div>
    <div class="flex h-[10%] flex-col items-start justify-end gap-4 4xl:text-3xl 5xl:text-4xl">
      <button class="flex flex-row items-center gap-2" @click="showBookCallPopup">
        <UIIcon name="calendar" />
        {{ $t('navigation.drawer.bookAppointment') }}
      </button>
      <button class="flex flex-row items-center gap-2" @click="showHelpPopup">
        <UIIcon name="shield" />
        {{ $t('navigation.drawer.helpSupport') }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { POPUPS } from '@/components/dynamic/maps'

const localePath = useLocalePath()

const uiStore = useUIStore()

const showBookCallPopup = () => {
  uiStore.showPopup(POPUPS.BOOK_A_CALL, {
    standaloneBooking: true,
  })
}

const showHelpPopup = () => {
  uiStore.showPopup(POPUPS.HELP_POPUP)
}
</script>

<style scoped></style>
